module.exports = ".control-fluid {\n    padding: 0px !important;\n}\n\nh1 {\n     font-family: Lato; \n}"